import React, { createContext, useState, useEffect } from 'react';
import { API_URL } from './constants';

export const ProjectsContext = createContext();

export const ProjectsProvider = ({ children }) => {
    const [projects, setProjects] = useState([]);
    const [articles, setArticles] = useState([]);
    const [drawings, setDrawings] = useState([]);
    const [reassuranceItems, setReassuranceItems] = useState([]);
    const [heroSettings, setHeroSettings] = useState(null);
    const [processSteps, setProcessSteps] = useState([]);
    const [aboutPageContent, setAboutPageContent] = useState(null);
    const [curiosityItems, setCuriosityItems] = useState([]);
    const [faqItems, setFaqItems] = useState([]);
    const [featuredProjects, setFeaturedProjects] = useState(null);
    const [approachSettings, setApproachSettings] = useState(null);
    const [homeBanner, setHomeBanner] = useState(null);
    const [processSettings, setProcessSettings] = useState(null);
    const [missionsSettings, setMissionsSettings] = useState(null);

    const [loadProjects, setLoadProjects] = useState(false);
    const [loadArticles, setLoadArticles] = useState(false);
    const [loadDrawings, setLoadDrawings] = useState(false);
    const [loadReassuranceItems, setLoadReassuranceItems] = useState(false);
    const [loadHeroSettings, setLoadHeroSettings] = useState(false);
    const [loadProcessSteps, setLoadProcessSteps] = useState(false);
    const [loadAboutPageContent, setLoadAboutPageContent] = useState(false);
    const [loadCuriosityItems, setLoadCuriosityItems] = useState(false);
    const [loadFaqItems, setLoadFaqItems] = useState(false);
    const [loadFeaturedProjects, setLoadFeaturedProjects] = useState(false);
    const [loadApproachSettings, setLoadApproachSettings] = useState(false);
    const [loadHomeBanner, setLoadHomeBanner] = useState(false);
    const [loadProcessSettings, setLoadProcessSettings] = useState(false);
    const [loadMissionsSettings, setLoadMissionsSettings] = useState(false);

    const [displayNavSection, setDisplayNavSection] = useState(false);
    const [loaderDisplay, setLoaderDisplay] = useState(false);
    const [welcomeDisplay, setWelcomeDisplay] = useState(false);
    const [currentPage, setCurrentPage] = useState('');

    /*---------------------------------------------
    ----- Chargement des projets et stockage ------
    ---------------------------------------------*/

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/projects`)
            .then((res) => res.json())
            .then((data) => {
                setProjects(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadProjects]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/articles`)
            .then((res) => res.json())
            .then((data) => {
                setArticles(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadArticles]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/drawings`)
            .then((res) => res.json())
            .then((data) => {
                setDrawings(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadDrawings]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/reassurance-items`)
            .then((res) => res.json())
            .then((data) => {
                setReassuranceItems(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadReassuranceItems]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/hero-settings`)
            .then((res) => res.json())
            .then((data) => {
                setHeroSettings(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadHeroSettings]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/approach-settings`)
            .then((res) => res.json())
            .then((data) => {
                setApproachSettings(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadApproachSettings]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/home-banner`)
            .then((res) => res.json())
            .then((data) => {
                setHomeBanner(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadHomeBanner]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/process-settings`)
            .then((res) => res.json())
            .then((data) => {
                setProcessSettings(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadProcessSettings]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/missions-settings`)
            .then((res) => res.json())
            .then((data) => {
                setMissionsSettings(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadMissionsSettings]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/process-steps`)
            .then((res) => res.json())
            .then((data) => {
                setProcessSteps(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadProcessSteps]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/about-page-content`)
            .then((res) => res.json())
            .then((data) => {
                setAboutPageContent(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadAboutPageContent]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/curiosity-items`)
            .then((res) => res.json())
            .then((data) => {
                setCuriosityItems(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadCuriosityItems]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/faq-items`)
            .then((res) => res.json())
            .then((data) => {
                setFaqItems(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadFaqItems]);

    useEffect(() => {
        setLoaderDisplay(true);

        fetch(`${API_URL}/api/featured-projects`)
            .then((res) => res.json())
            .then((data) => {
                setFeaturedProjects(data);
                setLoaderDisplay(false);
            })
            .catch((error) => {
                console.log(error.message);
                setLoaderDisplay(false);
            });
    }, [loadFeaturedProjects]);

    useEffect(() => {
        setWelcomeDisplay(true);

        setTimeout(function () {
            setWelcomeDisplay(false);
        }, 3000);
    }, []);

    const handleLoadProjects = () => {
        setLoadProjects(loadProjects === false ? true : false);
    };

    const handleLoadArticles = () => {
        setLoadArticles(loadArticles === false ? true : false);
    };

    const handleLoadDrawings = () => {
        setLoadDrawings(loadDrawings === false ? true : false);
    };

    const handleLoadReassuranceItems = () => {
        setLoadReassuranceItems(loadReassuranceItems === false ? true : false);
    };

    const handleLoadHeroSettings = () => {
        setLoadHeroSettings(loadHeroSettings === false ? true : false);
    };

    const handleLoadProcessSteps = () => {
        setLoadProcessSteps(loadProcessSteps === false ? true : false);
    };

    const handleLoadAboutPageContent = () => {
        setLoadAboutPageContent(loadAboutPageContent === false ? true : false);
    };

    const handleLoadCuriosityItems = () => {
        setLoadCuriosityItems(loadCuriosityItems === false ? true : false);
    };

    const handleLoadFaqItems = () => {
        setLoadFaqItems(loadFaqItems === false ? true : false);
    };

    const handleLoadFeaturedProjects = () => {
        setLoadFeaturedProjects(loadFeaturedProjects === false ? true : false);
    };

    const handleLoadApproachSettings = () => {
        setLoadApproachSettings(loadApproachSettings === false ? true : false);
    };

    const handleLoadHomeBanner = () => {
        setLoadHomeBanner(loadHomeBanner === false ? true : false);
    };

    const handleLoadProcessSettings = () => {
        setLoadProcessSettings(loadProcessSettings === false ? true : false);
    };

    const handleLoadMissionsSettings = () => {
        setLoadMissionsSettings(loadMissionsSettings === false ? true : false);
    };

    return (
        <ProjectsContext.Provider
            value={{
                handleLoadProjects,
                projects,
                handleLoadArticles,
                handleLoadDrawings,
                handleLoadReassuranceItems,
                handleLoadHeroSettings,
                handleLoadProcessSteps,
                handleLoadAboutPageContent,
                handleLoadCuriosityItems,
                handleLoadFaqItems,
                handleLoadFeaturedProjects,
                handleLoadApproachSettings,
                handleLoadHomeBanner,
                handleLoadProcessSettings,
                handleLoadMissionsSettings,
                articles,
                drawings,
                reassuranceItems,
                heroSettings,
                processSteps,
                aboutPageContent,
                curiosityItems,
                faqItems,
                featuredProjects,
                approachSettings,
                homeBanner,
                processSettings,
                missionsSettings,
                displayNavSection,
                setDisplayNavSection,
                loaderDisplay,
                setLoaderDisplay,
                welcomeDisplay,
                setWelcomeDisplay,
                currentPage,
                setCurrentPage,
            }}
        >
            {children}
        </ProjectsContext.Provider>
    );
};